import styled from 'styled-components';
import { Link } from '@tanstack/react-router';

export const StyledLink = styled(Link)`
  text-decoration: none;
  color: rgba(0, 0, 0, 0.5);
  font-weight: 500;
`;
